import React, { useContext, useState } from "react";
import Button from "../reusable/Button";
import Input from "../reusable/Input";
import { BaseURL } from "../BaseURL";
import toast from "react-hot-toast";
import { LuEye } from "react-icons/lu";
import { LuEyeOff } from "react-icons/lu";
import { LuMail } from "react-icons/lu";
import { LuLock } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { motion } from "framer-motion";
import GetLocalStorageValue from "../reusable/GetLocalStorageValue";
import { getSingleAccessibleProduct } from "../reusable/ProductAccess";

import WhiteBlueLogo from "../../img/logo-white-blue.webp";
import BlueBlackLogo from "../../img/logo-blue-black.webp";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { SignOutButton } from "../../msal-login/msal-login-buttons/SignOutButton";
import { SignInButton } from "../../msal-login/msal-login-buttons/SignInButton";
import msLogo from "../../img/ms-logo2.png";
import OutsideClickHandler from "react-outside-click-handler";
import { loginRequest } from "../../msal-login/auth-files/authConfig";

export default function Login() {
  const {
    setResToken,
    darkTheme,
    tokenMode,
    setTokenMode,
    setCodeNavigatorToken,
    setUserLoginInfo,
    userLoginInfo,
    isMsalLogin,
    setIsMsalLogin,
    setProduct,
  } = useContext(UserContext);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [toggle, setToggle] = useState("password");
  const [submitDisable, setSubmitDisable] = useState(false);

  const [isMsalLoginBtnOpen, setIsMsalLoginBtnOpen] = useState(false);

  const navigate = useNavigate();

  // MSAL LIB
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  // const loginFunc = async (e) => {
  //   e.preventDefault();
  //   if (!email) {
  //     toast.error("Enter Email or Username");
  //     return;
  //   }
  //   if (!password) {
  //     toast.error("Enter Password");
  //     return;
  //   }

  //   const loginPromise = new Promise(async (resolve, reject) => {
  //     setSubmitDisable(true);
  //     setTokenMode("");

  //     const loginData = {
  //       username: email,
  //       password: password,
  //     };
  //     const res = await fetch(`${BaseURL}/personal/login`, {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(loginData),
  //     });

  //     const resData = await res.json();
  //     if (resData.success) {
  //       if (resData.data.access_token) {
  //         setTokenMode("personal");
  //         // toast.success("Logged In");

  //         const storeInLocalStorage = {
  //           user_id: resData.data.user_id,
  //           user_name: resData.data.user_name,
  //           can_view_heading_id: resData.data.can_view_heading_id,
  //           can_view_chatbot: resData?.data?.can_view_chatbot
  //         };
  //         localStorage.setItem("uInfo", JSON.stringify(storeInLocalStorage));
  //         const gettingLocalStorageData = await GetLocalStorageValue(
  //           "uInfo",
  //           {}
  //         );
  //         await setUserLoginInfo(gettingLocalStorageData);
  //         // navigate("/");

  //         setIsMsalLogin(false);
  //         localStorage.removeItem("msInfo");
  //         localStorage.removeItem("previousUrl");
  //         localStorage.removeItem("currentUrl");
  //         localStorage.removeItem("versionNameId");
  //         localStorage.setItem("access_token", resData.data.access_token);
  //         localStorage.removeItem("cn_access_token");
  //         localStorage.removeItem("cn_rt");
  //         setCodeNavigatorToken("");
  //         setResToken(resData.data.access_token);

  //         setPassword("");
  //         setEmail("");

  //         navigate("/");
  //         setSubmitDisable(false);
  //       } else {
  //         toast.error("Session issues");
  //         setSubmitDisable(false);
  //       }
  //       resolve();
  //     } else {
  //       // toast.error("Wrong Credentials !");
  //       setSubmitDisable(false);
  //       navigate("/");
  //       reject();
  //     }
  //   });

  //   // const gettingLocalStorageData = await GetLocalStorageValue("uInfo", {});
  //   await toast.promise(loginPromise, {
  //     loading: "Loading..",
  //     success: `Logged In`,
  //     // success: `Welcome ${gettingLocalStorageData.user_name}`,
  //     error: "Wrong Credentials !",
  //   });
  // };

  // work good
  // const loginFunc = async (e) => {
  //   e.preventDefault();
  //   if (!email) {
  //     toast.error("Enter Email or Username");
  //     return;
  //   }
  //   if (!password) {
  //     toast.error("Enter Password");
  //     return;
  //   }

  //   const loginPromise = async () => {
  //     setSubmitDisable(true);
  //     setTokenMode("");

  //     const loginData = {
  //       username: email,
  //       password: password,
  //     };
  //     const res = await fetch(`${BaseURL}/personal/login`, {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(loginData),
  //     });

  //     const resData = await res.json();
  //     if (!resData.success) {
  //       throw new Error("Wrong Credentials");
  //     } else if (resData.success) {
  //       if (resData.data.access_token) {
  //         setTokenMode("personal");
  //         // toast.success("Logged In");

  //         const storeInLocalStorage = {
  //           user_id: resData.data.user_id,
  //           user_name: resData.data.user_name,
  //           can_view_heading_id: resData.data.can_view_heading_id,
  //           can_view_chatbot: resData?.data?.can_view_chatbot,
  //         };
  //         localStorage.setItem("uInfo", JSON.stringify(storeInLocalStorage));
  //         const gettingLocalStorageData = await GetLocalStorageValue(
  //           "uInfo",
  //           {},
  //         );
  //         await setUserLoginInfo(gettingLocalStorageData);
  //         // navigate("/");

  //         setIsMsalLogin(false);
  //         localStorage.removeItem("msInfo");
  //         localStorage.removeItem("previousUrl");
  //         localStorage.removeItem("currentUrl");
  //         localStorage.removeItem("versionNameId");
  //         localStorage.setItem("access_token", resData.data.access_token);
  //         localStorage.removeItem("cn_access_token");
  //         localStorage.removeItem("cn_rt");
  //         setCodeNavigatorToken("");
  //         setResToken(resData.data.access_token);

  //         setPassword("");
  //         setEmail("");

  //         navigate("/");
  //       } else {
  //         toast.error("Session issues");
  //       }
  //     } else {
  //       // toast.error("Wrong Credentials !");
  //       navigate("/");
  //     }
  //   };

  //   try {
  //     await toast.promise(loginPromise(), {
  //       loading: "Loading...",
  //       success: "Logged In",
  //       error: (err) => err.message,
  //     });
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setSubmitDisable(false);
  //   }
  // };

  const loginFunc = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Enter Email or Username");
      return;
    }

    if (!password.trim()) {
      toast.error("Enter Password");
      return;
    }

    setSubmitDisable(true);
    setTokenMode("");

    try {
      await toast.promise(
        (async () => {
          const loginData = {
            username: email.trim(),
            password,
          };

          const response = await fetch(`${BaseURL}/personal/login`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(loginData),
          });

          let resData;

          try {
            resData = await response.json();
          } catch {
            throw new Error("Invalid server response.");
          }

          if (!response.ok) {
            throw new Error(
              resData?.message || "Unable to login. Please try again.",
            );
          }

          if (!resData?.success) {
            throw new Error(resData?.message || "Wrong Credentials!");
          }

          if (!resData?.data?.access_token) {
            throw new Error("Session issues. Please login again.");
          }

          setTokenMode("personal");

          const storeInLocalStorage = {
            user_id: resData.data.user_id,
            user_name: resData.data.user_name,
            can_view_heading_id: resData.data.can_view_heading_id,
            can_view_chatbot: resData.data.can_view_chatbot,
            can_view_codenavigator: resData.data.can_view_codenavigator,
            can_view_continuum: resData.data.can_view_continuum,
          };

          localStorage.setItem("uInfo", JSON.stringify(storeInLocalStorage));

          const gettingLocalStorageData = await GetLocalStorageValue(
            "uInfo",
            {},
          );

          await setUserLoginInfo(gettingLocalStorageData);

          // Date: 11 Aug 2026
          // Ref: Skip the KB chooser entirely for a single-product-access user
          // -- land them straight on their one product (see MainWrapper's
          // routing, which redirects "/" to whichever product is set here).
          const singleAccessProduct = getSingleAccessibleProduct(
            gettingLocalStorageData,
          );
          if (singleAccessProduct) {
            setProduct(singleAccessProduct);
          }

          setIsMsalLogin(false);

          localStorage.removeItem("msInfo");
          localStorage.removeItem("previousUrl");
          localStorage.removeItem("currentUrl");
          localStorage.removeItem("versionNameId");
          localStorage.removeItem("cn_access_token");
          localStorage.removeItem("cn_rt");

          localStorage.setItem("access_token", resData.data.access_token);

          setCodeNavigatorToken("");
          setResToken(resData.data.access_token);

          setEmail("");
          setPassword("");

          navigate("/");

          return resData;
        })(),
        {
          loading: "Logging in...",
          success: "Logged In",
          error: (err) => err?.message || "Unable to login. Please try again.",
        },
      );
    } catch (err) {
      console.error("Login Error:", err);
    } finally {
      setSubmitDisable(false);
    }
  };

  const handleMSLogin = (loginType) => {
    if (loginType === "popup") {
      setIsMsalLogin(true);

      instance
        .loginPopup(loginRequest)
        .then((res) => {
          if (res.accessToken) {
            navigate("/authentication");
          }
        })
        .catch((e) => {
          console.log("msal_loginPopup-error==>", e);
          setIsMsalLogin(false);
          toast.error(
            "Sign-in with Microsoft was interrupted. Please try again.",
          );
        });
    } else if (loginType === "redirect") {
      setIsMsalLogin(true);

      instance.loginRedirect(loginRequest).catch((e) => {
        console.log("msal_loginRedirect-error==>", e);
        setIsMsalLogin(false);
        toast.error(
          "Sign-in with Microsoft was interrupted. Please try again.",
        );
      });
    }
  };
  return (
    <motion.div
      className="px-3 flex items-center justify-center HeightHome flex-col gap-y-4"
      initial={{ opacity: 0, y: 25 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 1, y: 25 }}
      transition={{ delay: 0.3, type: "easeInOut", duration: 0.7 }}
    >
      <div
        className={`w-full md:w-[26rem] rounded-3xl p-6 md:p-10 border transition-colors mt-10 md:mt-16 ${
          darkTheme
            ? "bg-[#2c2c2c] border-white/5 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.55)]"
            : "bg-White border-Black/[0.04] shadow-[0_25px_60px_-15px_rgba(10,77,220,0.18)]"
        }`}
      >
        <div className="flex items-center justify-center mb-5 md:mb-6">
          {darkTheme ? (
            <img
              className="w-28 md:w-32"
              // src="./assets/logo-white.webp"
              src={WhiteBlueLogo}
              alt="logo"
            />
          ) : (
            <img className="w-28 md:w-32" src={BlueBlackLogo} alt="logo" />
          )}
        </div>

        <div className="text-center mb-6">
          <p
            className={`text-lg font-semibold font-Barlow_medium ${
              darkTheme ? "text-White" : "text-Black"
            }`}
          >
            Welcome back
          </p>
          <p
            className={`text-sm mt-1 ${
              darkTheme ? "text-[#9a9a9a]" : "text-gray"
            }`}
          >
            Sign in to continue to your workspace
          </p>
        </div>

        <form>
          <div className="flex flex-col gap-4">
            <div className="relative">
              <LuMail
                className={`w-[18px] h-[18px] absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none z-10 ${
                  darkTheme ? "text-[#8a8a8a]" : "text-[#9aa1ac]"
                }`}
              />
              <Input
                type="email"
                placeholder="Email or Username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`w-full !pl-11 !pr-4 !py-3.5 !rounded-2xl border !outline-none transition-colors ${
                  darkTheme
                    ? "!bg-[#333333] border-white/10 !text-White placeholder:text-[#7f7f7f] focus:border-cfBlue"
                    : "!bg-White border-[#e3e6ec] focus:border-cfBlue focus:shadow-[0_0_0_3px_rgba(10,77,220,0.12)]"
                }`}
              />
            </div>

            <div className="relative">
              <LuLock
                className={`w-[18px] h-[18px] absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none z-10 ${
                  darkTheme ? "text-[#8a8a8a]" : "text-[#9aa1ac]"
                }`}
              />
              <Input
                type={toggle}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`w-full !pl-11 !pr-11 !py-3.5 !rounded-2xl border !outline-none transition-colors ${
                  darkTheme
                    ? "!bg-[#333333] border-white/10 !text-White placeholder:text-[#7f7f7f] focus:border-cfBlue"
                    : "!bg-White border-[#e3e6ec] focus:border-cfBlue focus:shadow-[0_0_0_3px_rgba(10,77,220,0.12)]"
                }`}
              />

              <button
                type="button"
                tabIndex={-1}
                className={`absolute right-3 top-1/2 -translate-y-1/2 z-10 p-1.5 rounded-lg transition-colors ${
                  darkTheme
                    ? "text-[#8a8a8a] hover:text-White hover:bg-white/5"
                    : "text-[#9aa1ac] hover:text-Black hover:bg-Black/[0.04]"
                }`}
                onClick={() =>
                  setToggle(toggle === "password" ? "text" : "password")
                }
              >
                {toggle === "password" ? (
                  <LuEye className="w-[18px] h-[18px]" />
                ) : (
                  <LuEyeOff className="w-[18px] h-[18px]" />
                )}
              </button>
            </div>
          </div>

          <button
            disabled={submitDisable}
            type="submit"
            className={`flex items-center justify-center rounded-2xl bg-cfBlue text-White transition-all font-medium font-Barlow_medium my-5 w-full py-3 shadow-[0_12px_24px_-8px_rgba(10,77,220,0.55)] ${
              submitDisable
                ? "opacity-70 cursor-not-allowed"
                : "hover:brightness-110 hover:shadow-[0_16px_30px_-8px_rgba(10,77,220,0.6)] active:scale-[0.99]"
            }`}
            onClick={(e) => loginFunc(e)}
          >
            {submitDisable ? "Logging in..." : "Login"}
          </button>

          <div className="flex items-center gap-3 mb-5">
            <div
              className={`h-px flex-1 ${
                darkTheme ? "bg-white/10" : "bg-Black/[0.08]"
              }`}
            />
            <span
              className={`text-xs uppercase tracking-wide ${
                darkTheme ? "text-[#8a8a8a]" : "text-gray"
              }`}
            >
              or
            </span>
            <div
              className={`h-px flex-1 ${
                darkTheme ? "bg-white/10" : "bg-Black/[0.08]"
              }`}
            />
          </div>

          {/* MSAL LOGIN BTN  */}
          <OutsideClickHandler
            onOutsideClick={() => setIsMsalLoginBtnOpen(false)}
          >
            <button
              type="button"
              className={`w-full flex items-center justify-center gap-2 transition-all rounded-2xl font-medium font-Barlow_medium py-3 border ${
                darkTheme
                  ? "text-White bg-[#3a3a3a] border-white/5 hover:bg-[#454545]"
                  : "text-Black bg-White border-Black/[0.08] hover:shadow-md hover:border-Black/[0.14]"
              }`}
              // onClick={() => setIsMsalLoginBtnOpen(!isMsalLoginBtnOpen)}
              // Date: 11 Sep 2026
              // Ref: Popup-based sign-in relies on the browser letting the
              // opener window read/close a same-origin popup; this is flaky
              // across browsers (Safari/Brave/some Chrome profiles) and was
              // the cause of "signs in, then dumps back to Login" reports.
              // Redirect avoids that whole class of cross-window issues.
              onClick={() => handleMSLogin("redirect")}
            >
              <img className={`w-5`} src={msLogo} alt="ms-logo" />
              Sign In with Microsoft
            </button>
            {/* <div>
              {isMsalLoginBtnOpen && (
                <div
                  className={`absolute z-20 py-2 px-4 rounded-xl mt-2 ${
                    darkTheme ? "bg-cfBlue" : "bg-White"
                  }`}
                >
                  {isAuthenticated ? <SignOutButton /> : <SignInButton />}
                </div>
              )}
            </div> */}
          </OutsideClickHandler>
        </form>
      </div>
    </motion.div>
  );
}
